import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddHolidayNotificationModal = React.lazy(
  () => import("./add-holiday-notification..modal"),
);

const AddHolidayNotification: iModalProps<
  typeof AddHolidayNotificationModal,
  { workflowId?: string }
> = {
  name: "add-holiday-notification",
  component: GenerateModalWithSuspense(AddHolidayNotificationModal),
};

export default AddHolidayNotification;
